import { PageLayoutsFormValidationSchema } from '../../../../pageLayouts.interface';


export const pageLayoutsFormValidationSchema: PageLayoutsFormValidationSchema = {
  name: [
    { required: true, message: 'Введіть назву макету' },
    { type: 'string', message: 'Назва має бути строкою' },
    { min: 3, max: 100, message: 'Назва має бути довжиною не менше 3 символів та не більше 100' }
  ],
  content: [
    { required: true, message: 'Задайте вміст макету' },
    { type: 'string', message: 'Вміст має бути строкою' },
    {
      min: 3,
      max: Number.MAX_SAFE_INTEGER,
      message: `Вміст має бути довжиною не менше 3 символів та не більше ${ Number.MAX_SAFE_INTEGER }`
    }
  ]
};
